//imagen

//Stand

//Backing

//Puntos de Atencion
import mesaAtencion from './../../Img/productos/Mesa-Atencion.jpg';
import mesaPresentacion from './../../Img/productos/Mesa-de-presentación.jpg';
import mesaplasma from './../../Img/productos/Porta-Plasmas.jpg';
import puntoAtenciom from './../../Img/productos/Punto-de-Atencion.jpg';
import mesaPortapendon from './../../Img/productos/Mesa-PortaPendones.jpg';

//Mesa Centro 
import mesaDoble from './../../Img/productos/Mesa-doble.jpg';
import mesaTrabajo from './../../Img/productos/Mesa-de-trabajo-1-100.jpg';
//import mesaDobleP from './../../Img/productos/Mesa-Doble-Publicidad.jpg';
import mesaXm2 from './../../Img/productos/Mesa-XM2.jpg';
import mesaWorm from './../../Img/productos/Mesa-Worm.png';
import mesaBar from './../../Img/productos/Mesa-Bar.jpg';

//Impresion
import impresion from './../../Img/productos/Impreso-1-01.jpg';
import revisteros from './../../Img/productos/Revisteros.jpg';
import vitrinasPublicitarias from './../../Img/productos/Vitrinas-Publicitaria.jpg';


export const Stand = [
  {
    img: mesaPresentacion,
    name: 'Mesa de presentación'
  },
  {
      img: revisteros,
      name: 'Revisteros'
  },
  {
    img: vitrinasPublicitarias,
    name: 'Vitrina Publicitaria'
  }
];

export const puntoAtencion =[
    {
        img: mesaAtencion,
        name: 'Mesa de Atención'
    },
    {
        img: mesaplasma,
        name: 'Mesa Porta plasma'
    },
    {
        img: puntoAtenciom,
        name: 'Puntos de Atención'
    },
    {
        img: mesaPortapendon,
        name: 'Mesa PortaPendon'
    },
]

export const MesaCentro = [
    {
        img: mesaDoble,
        name: 'Mesa Doble con Acrilico'
    },
    {
        img: mesaTrabajo,
        name: 'Mesa de Trabajo'
    },
    // {
    //     img: mesaDobleP,
    //     name: 'Mesa doble con Publicidad'
    // },
    {
        img: mesaXm2,
        name: 'Mesa XM2'
    },
    {
        img: mesaWorm,
        name: 'Mesa Worm'
    },
    {
        img: mesaBar,
        name: 'Mesa Bar'
    },
]

export const Impresionn = [
    {
        img: impresion,
        name: 'Porta Pendon'
    }
    
]

export const name = [
    {
        data:'jonathan alexander casas ballen'
    }
];



// WEBPACK FOOTER //
// ./src/Pages/Productos/product.js